import React from "react";
import useFullDimensions from "./useFullDimensions";
import BootstrapBreakpointService from "../../Domain/BootstrapBreakpoint/BootstrapBreakpoint.service";
const useBootstrapBreakpoint = (delay) => {
    const { width } = useFullDimensions(delay);
    return React.useMemo(() => BootstrapBreakpointService.getBreakpointForWidth(width), [width]);
};
export default useBootstrapBreakpoint;
